import React, { useState, useContext } from "react";
import style from "./Bulk.module.scss";
import { Dispatch } from "../../store/store";
import Assets from "./Assets";

const Bulk = ({ ...props }) => {
  const { dispatch, services, state } = useContext(Dispatch);
  const { io, fields, entities } = state;
  const { errors, readonly } = fields;

  const header = io.itemsHeader;

  return (
    <React.Fragment>
      <Assets
        readonly={readonly.Date}
        itemsHeader={io.itemsHeader}
        isCurrency={header.IsCurrency}
        ioType={io.IOType}
        items={io.items}
        accountId={header.AccountId}
        local={io.Local}
        entities={entities}
        dispatch={dispatch}
        error={errors.items}
        services={services}
      />
    </React.Fragment>
  );
};

export default Bulk;
